import React from "react";
import { Typography, TypographyProps } from "@mui/material";

interface IProps extends TypographyProps {
  heading: string;
}

const TabHeading: React.FC<IProps> = ({ heading, ...props }) => {
  return (
    <Typography
      variant="h2"
      fontSize={{ xs: "1.25rem", md: "2rem", lg: "2.5rem" }}
      mb={2}
      {...props}
    >
      {heading}
    </Typography>
  );
};

export default TabHeading;
